/**
 * Factory for creating UserOnboardingService instances based on authentication provider
 */

import AuthenticationProviderEnum from '../../config/authenticationProviderEnum';
import OnecloudUserOnboardingService from './OnecloudUserOnboardingService';
import StratusUserOnboardingService from './StratusUserOnboardingService';
import IUserOnboardingService from './IUserOnboardingService';
import { UserOnboardingInputType } from '../../infra/startup/types';

/**
 * Parameters for creating UserOnboardingService strategies
 */
export interface IUserOnboardingServiceFactoryParams {
  authenticationProvider: AuthenticationProviderEnum;
  userOnboarding: UserOnboardingInputType;
}

/**
 * Factory Pattern to encapsulate UserOnboardingService creation logic
 */
export class UserOnboardingServiceFactory {
  /**
   * Creates the appropriate UserOnboardingService based on the authentication provider
   */
  static createService(
    params: IUserOnboardingServiceFactoryParams
  ): IUserOnboardingService {
    const { authenticationProvider, userOnboarding } = params;

    if (authenticationProvider === AuthenticationProviderEnum.coptor) {
      return new OnecloudUserOnboardingService(userOnboarding);
    } else {
      return new StratusUserOnboardingService(userOnboarding);
    }
  }

  /**
   * Returns available service types
   */
  static getAvailableServices(): string[] {
    return ['OnecloudUserOnboardingService', 'StratusUserOnboardingService'];
  }
}
